<template>
  <div class="div" v-loading="loading">
    <div class="div-top" style="margin-top: 10px">
      <el-input
        v-model="searchData.Keyword"
        placeholder="请输入设备名称"
        clearable
        style="width: 300px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button type="warning" @click="SplitData" style="margin-left: 10px"
        >设备拆分</el-button
      >
      <el-button type="primary" @click="openList">已拆分列表</el-button>
      <el-button
        type="success"
        @click="handleVerify"
        style="margin-left: 10px"
        icon="el-icon-circle-check"
        >接收数据</el-button
      >
      <!-- <el-button type="primary" @click="handleAdd" style="margin-left: 10px"
      icon="el-icon-upload2"
        >导入初始化数据</el-button
      > -->
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="设备编号"
          align="center"
          prop="device_no"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备名称"
          align="center"
          prop="device_name"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备型号"
          align="center"
          prop="model_number"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备规格"
          align="center"
          prop="specification"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="生产厂家名称"
          align="center"
          prop="manufacturer"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="购置价格"
          align="center"
          prop="purchase_price"
          sortable
        >
        </el-table-column>
        <el-table-column label="设备数量" align="center" prop="Num" sortable>
        </el-table-column>

        <el-table-column
          label="拆分状态"
          align="center"
          prop="SplitStatus"
          sortable
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.SplitStatus === 0">未拆分</el-tag>
            <el-tag v-else-if="scope.row.SplitStatus === 1" type="success"
              >已拆分</el-tag
            >
          </template>
        </el-table-column>
        <!-- <el-table-column label="接收状态" align="center" prop="ReceiveStatus">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ReceiveStatus === 0">未接收</el-tag>
            <el-tag v-else-if="scope.row.ReceiveStatus === 1" type="success"
              >已接收</el-tag
            >
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.SplitStatus === 1"
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >还原</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <DataList ref="DataList" @refreshData="getDataList"></DataList>
    <el-dialog
      :visible.sync="LoadingVisible"
      width="30%"
      custom-class="loading-dialog"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 20px">
        <i class="el-icon-loading"></i> 拆分中，请稍等...
      </div>
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        text-color="#fff"
        :percentage="loadingNum"
        status="success"
      ></el-progress>
    </el-dialog>
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import Token from '@/utils/cache/TokenCache.js'
import DataList from './DataList.vue'

import { Loading } from 'element-ui'
export default {
  data() {
    return {
      token: 'Bearer ' + Token.getToken(),
      searchData: {
        Condition: 'device_name',
        Keyword: '',
      },
      LoadingVisible: false,
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      loadingNum: 0,
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { DataList },
  methods: {
    selectable(row) {
      return row.SplitStatus === 0
    },
    openList() {
      this.$refs.DataList.openList('已拆分列表')
    },
    SplitData() {
      console.log(this.selectedRows)
      if (this.selectedRows.length === 0) {
        this.$notify.error('请至少选择一个设备进行拆分')
        return
      }
      this.$confirm('此操作将会将拆分设备数量, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.LoadingVisible = true
        // this.selectedRows
        for (let i = 0; i < this.selectedRows.length; i++) {
          let res = await this.$http.post(
            '/Base_DeviceTreeManage/Device/SplitData',
            [this.selectedRows[i].Id]
          )
          if (res.Success) {
            this.$notify.success(this.selectedRows[i].device_name + '拆分成功')
            this.loadingNum =
              this.loadingNum + Math.floor(100 / this.selectedRows.length)
          } else {
            this.$notify.error(this.selectedRows[i].device_name + '拆分失败')
            this.$notify.error(res.Msg)
          }

          // this.loadingNum = Math.floor((i / this.selectedRows.length) * 100);
        }
        this.LoadingVisible = false
        this.getDataList()
        // this.$http
        //   .post(
        //     "/Base_DeviceTreeManage/Device/SplitData",
        //     this.selectedRows.map((item) => item.Id)
        //   )
        //   .then((resJson) => {
        //     this.loading = false;
        //     if (resJson.Success) {
        //       this.$notify.success("拆分成功");
        //       this.getDataList();
        //     } else {
        //       this.$notify.error(resJson.Msg);
        //     }
        //   });
      })
    },
    handleVerify() {
      this.$confirm(
        '此操作将会将已拆分设备数据导入到台账信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          const loadingInstance = Loading.service({
            fullscreen: true,
            text: '正在接收中...',
          })
          this.$http
            .post('/Base_DeviceTreeManage/DeviceItem/ReceiveData', {})
            .then((resJson) => {
              loadingInstance.close()
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('接收成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleExport() {
      tools.download(
        this.$rootUrl + '/Base/Base_Device/ExportDeviceToExcel',
        '资产设备',
        '.xlsx',
        'get'
      )
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'SplitStatus',
          SortType: 'asc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建用户')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将还原该设备拆分, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/DeviceItem_Temp/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('还原成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
div {
  padding: 0;
}
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 40px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .loading-dialog .el-dialog__header {
  display: none;
}
::v-deep .loading-dialog .el-dialog__body {
  padding: 30px;
}
</style>
